import {MotDePasseOublie} from "./MotDePasseOublie";
export default MotDePasseOublie;